import { ButtonBoxedPrimary, ButtonBoxedPrimaryNegative } from "@/lib/styles";
import styled from "styled-components";

export const Container = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: solid 1px;
  border-color: ${({ theme }) => theme.colors.middleGrey};
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1rem;
  gap: 1rem;
`;

export const SecondaryButton = styled(ButtonBoxedPrimaryNegative)`
  flex: 1;
  font-size: 1.25rem;
  font-weight: 400;
`;
export const PrimaryButton = styled(ButtonBoxedPrimary)`
  flex: 1;
  font-size: 1.25rem;
`;
